import classNames from "classnames";

const Subtitle = (props: React.HTMLAttributes<HTMLParagraphElement>) => {
    return <h1 {...props} className={classNames(`text-h3 font-light text-primary`, props.className)}>{props.children}</h1>;
}

export default Subtitle;